
import React from 'react'

export const Getnumbersinstring = (sentence : any) => {
    const originalString = sentence;
    const index = originalString.search(/\d+/);
    const number = index !== -1 ? originalString.slice(index, index + originalString.slice(index).search(/\D/)) : 0
  
    return (number)
  }
  
  export const Getfirsttwowords = (sentence : any) => {
  
  
    const two_word_string = sentence.split(' ').slice(0, 2).join(' ').replace(/[0-9]/g, "")
  
    return (two_word_string)
  }
  
  
  
  